import { CollectionModel } from '@ikegps/core-shared';
import { Services } from '../index';

export interface SavePendingTargetsOptions {
	sourceCollection: CollectionModel;
	targetCollections: CollectionModel[];
}

export interface SavePendingTargetsResult {
	savedTargetIds: string[];
	failedTargetIds: string[];
}

/**
 * Save all target collections that have been modified by span link/unlink operations.
 * Each target is saved with a `spanLinkedPoleUuid` modification pointing to the source collection.
 *
 * After each successful target save, `finishEdit()` is called on the
 * target collection to drop its proxy state.
 *
 * This function should be called AFTER the source collection has been
 * saved successfully. If the source save failed, do not call this.
 */
export async function savePendingSpanTargets(options: SavePendingTargetsOptions): Promise<SavePendingTargetsResult> {
	const { sourceCollection, targetCollections } = options;

	const savedTargetIds: string[] = [];
	const failedTargetIds: string[] = [];

	for (const targetCollection of targetCollections) {
		const targetId = targetCollection.id;
		try {
			await Services.Collection.save(targetCollection, {
				spanLinkedPoleUuid: sourceCollection.uuid,
			});
			targetCollection.finishEdit();
			savedTargetIds.push(targetId);
		} catch (error) {
			Services.Log.Logger.error(`Failed to save target collection ${targetId} after span link: ${error}`);
			failedTargetIds.push(targetId);
		}
	}

	return { savedTargetIds, failedTargetIds };
}
